import styled from '@emotion/styled'
import { css } from '@emotion/react'
import React from 'react'

const SubHeadingStyle = styled.h4`
  color: #ffffff;
  font-size: 18px;
  font-family: 'poppins';
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: ${props => props.mb};
  margin-top: ${props => props.mt};
`

export const SubHeading = (props) => {
  return (
    <SubHeadingStyle className='mr-3' mb={props.mb ? props.mb : '1.5rem'} mt={props.mt ? props.mt : '0rem'}>{props.children}</SubHeadingStyle>
  )
}
